/**
 * @generated SignedSource<<f8caacd9b8d310d7ea88519c69cdb05d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowPdpSharedShoppingButtons_viewer$data = {
  readonly ipRegionalInfo: ReadonlyArray<{
    readonly countryCode: string | null;
  } | null> | null;
  readonly restrictAddToCartOutsideUs: boolean | null;
  readonly " $fragmentType": "useShowPdpSharedShoppingButtons_viewer";
};
export type useShowPdpSharedShoppingButtons_viewer$key = {
  readonly " $data"?: useShowPdpSharedShoppingButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowPdpSharedShoppingButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowPdpSharedShoppingButtons_viewer",
  "selections": [
    {
      "alias": "restrictAddToCartOutsideUs",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "restrictAddToCartOutsideUs"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"restrictAddToCartOutsideUs\")"
    },
    {
      "alias": "ipRegionalInfo",
      "args": null,
      "concreteType": "RegionalInfo",
      "kind": "LinkedField",
      "name": "regionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "90156d1b1d6ecbf0ebf49ccff7c3688c";

export default node;
